import { useFavorites } from '../../../hooks/useFavorites';

interface FavoriteButtonProps {
  movieId: string;
}

export default function FavoriteButton({ movieId }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  return (
    <button
      type="button"
      onClick={() => toggleFavorite(movieId)}
      className={`flex items-center gap-2 h-11 px-6 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
        active
          ? 'bg-accent-500 text-secondary-950 hover:bg-accent-600'
          : 'bg-background-50 border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600'
      }`}
      aria-pressed={active}
    >
      <i className={active ? 'ri-bookmark-fill text-base' : 'ri-bookmark-line text-base'} aria-hidden="true"></i>
      {active ? '已收藏' : '加入收藏'}
    </button>
  );
}